import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const BRAND = '#facc15';
const BRAND_RGB = '250,204,21';

const AppBarComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { text: 'Analisar', path: '/app', icon: '📊' },
    { text: 'Documentos', path: '/app/documentos', icon: '📁' },
    ...(user && user.perfil === 'admin' ? [{ text: 'Usuários', path: '/app/usuarios', icon: '👥' }] : []),
  ];

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <>
      <style>{`
        .nav-link-app { color: rgba(241,245,249,0.6); text-decoration: none; font-size: 0.88rem; font-weight: 500; padding: 6px 14px; border-radius: 10px; transition: all 0.2s; display: flex; align-items: center; gap: 7px; }
        .nav-link-app:hover { color: #f1f5f9; background: rgba(255,255,255,0.06); }
        .nav-link-app.active { color: ${BRAND}; background: rgba(${BRAND_RGB},0.08); }
        .btn-logout { background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.25); color: #fca5a5; border-radius: 10px; padding: 7px 16px; font-size: 0.85rem; font-weight: 600; cursor: pointer; transition: all 0.2s; display: flex; align-items: center; gap: 6px; }
        .btn-logout:hover { background: rgba(239,68,68,0.2); }
      `}</style>

      <nav style={{ background:'rgba(2,6,23,0.97)', backdropFilter:'blur(24px)', borderBottom:`1px solid rgba(${BRAND_RGB},0.1)`, position:'sticky', top:0, zIndex:200, padding:'0 24px' }}>
        <div style={{ maxWidth:1400, margin:'0 auto', display:'flex', alignItems:'center', height:60, justifyContent:'space-between' }}>
          {/* Logo */}
          <div style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }} onClick={() => navigate('/app')}>
            <div style={{ width:32, height:32, borderRadius:9, background:`rgba(${BRAND_RGB},0.15)`, border:`1px solid rgba(${BRAND_RGB},0.3)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.95rem' }}>📊</div>
            <span style={{ fontWeight:800, color:BRAND, fontSize:'1rem' }}>Delator</span>
            <span style={{ fontSize:'0.65rem', color:'rgba(241,245,249,0.3)', fontWeight:500 }}>Auditoria Financeira</span>
          </div>

          {/* Menu desktop */}
          <div className="d-none d-md-flex" style={{ alignItems:'center', gap:4 }}>
            {menuItems.map(m => (
              <button key={m.path} onClick={() => navigate(m.path)}
                className={`nav-link-app ${location.pathname === m.path ? 'active' : ''}`}
                style={{ background:'transparent', border:'none', cursor:'pointer' }}>
                <span>{m.icon}</span> {m.text}
              </button>
            ))}
          </div>

          {/* Direita */}
          <div className="d-none d-md-flex" style={{ alignItems:'center', gap:12 }}>
            {user && (
              <div style={{ fontSize:'0.8rem', color:'rgba(241,245,249,0.4)', display:'flex', alignItems:'center', gap:8 }}>
                <span style={{ width:28, height:28, borderRadius:'50%', background:`rgba(${BRAND_RGB},0.15)`, border:`1px solid rgba(${BRAND_RGB},0.25)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.75rem', fontWeight:700, color:BRAND }}>
                  {(user.nome_completo?.trim() || user.username || '?')[0].toUpperCase()}
                </span>
                <span>{user.nome_completo || user.username}</span>
              </div>
            )}
            <button className="btn-logout" onClick={handleLogout}>⏻ Sair</button>
          </div>

          {/* Mobile hamburger */}
          <button className="d-md-none" onClick={() => setMenuOpen(!menuOpen)}
            style={{ background:'transparent', border:`1px solid rgba(${BRAND_RGB},0.3)`, borderRadius:10, padding:'7px 12px', color:BRAND, cursor:'pointer' }}>☰</button>
        </div>

        {/* Mobile drawer */}
        {menuOpen && (
          <div style={{ background:'rgba(2,6,23,0.99)', borderTop:`1px solid rgba(${BRAND_RGB},0.1)`, padding:'12px 0 16px' }}>
            {menuItems.map(m => (
              <button key={m.path} onClick={() => { navigate(m.path); setMenuOpen(false); }}
                style={{ display:'flex', width:'100%', alignItems:'center', gap:10, padding:'12px 24px', background: location.pathname === m.path ? `rgba(${BRAND_RGB},0.06)` : 'transparent', border:'none', color: location.pathname === m.path ? BRAND : 'rgba(241,245,249,0.7)', fontSize:'0.95rem', cursor:'pointer', textAlign:'left' }}>
                <span>{m.icon}</span> {m.text}
              </button>
            ))}
            <div style={{ padding:'12px 24px 0', borderTop:'1px solid rgba(255,255,255,0.05)', marginTop:8 }}>
              <button className="btn-logout" onClick={handleLogout} style={{ width:'100%', justifyContent:'center' }}>⏻ Sair</button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default AppBarComponent;
